import { render, staticRenderFns } from "./OrderSendInputPage.vue?vue&type=template&id=53e2e44f&scoped=true&"
import script from "./OrderSendInputPage.vue?vue&type=script&lang=js&"
export * from "./OrderSendInputPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2e44f",
  null
  
)

export default component.exports